"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.propertyDefinition = propertyDefinition;
const property_1 = require("@genesys/property");
function propertyDefinition() {
    return [
        {
            sort_no: 1,
            name: "coefficientsadry",
            group: "",
            quantity: "Dimensionless",
            validation_filter: property_1.PropertyFilter.Empty,
            visibility_filter: property_1.PropertyFilter.Empty,
            value: []
        },
        {
            sort_no: 2,
            name: "coefficientsbdry",
            group: "",
            quantity: "Dimensionless",
            validation_filter: property_1.PropertyFilter.Empty,
            visibility_filter: property_1.PropertyFilter.Empty,
            value: []
        },
        {
            sort_no: 3,
            name: "coefficientscdry",
            group: "",
            quantity: "Dimensionless",
            validation_filter: property_1.PropertyFilter.Empty,
            visibility_filter: property_1.PropertyFilter.Empty,
            value: []
        },
        {
            sort_no: 4,
            name: "coefficientsddry",
            group: "",
            quantity: "Dimensionless",
            validation_filter: property_1.PropertyFilter.Empty,
            visibility_filter: property_1.PropertyFilter.Empty,
            value: []
        },
        {
            sort_no: 5,
            name: "coefficientsawet",
            group: "",
            quantity: "Dimensionless",
            validation_filter: property_1.PropertyFilter.Empty,
            visibility_filter: property_1.PropertyFilter.Empty,
            value: []
        },
        {
            sort_no: 6,
            name: "coefficientsbwet",
            group: "",
            quantity: "Dimensionless",
            validation_filter: property_1.PropertyFilter.Empty,
            visibility_filter: property_1.PropertyFilter.Empty,
            value: []
        },
        {
            sort_no: 7,
            name: "coefficientscwet",
            group: "",
            quantity: "Dimensionless",
            validation_filter: property_1.PropertyFilter.Empty,
            visibility_filter: property_1.PropertyFilter.Empty,
            value: []
        },
        {
            sort_no: 8,
            name: "coefficientsdwet",
            group: "",
            quantity: "Dimensionless",
            validation_filter: property_1.PropertyFilter.Empty,
            visibility_filter: property_1.PropertyFilter.Empty,
            value: []
        }
    ];
}
//# sourceMappingURL=coefficients-definition.js.map